import { Link } from "react-router-dom";
import { useSEO } from "@/hooks/useSEO";

const NotFound = () => {
  useSEO({ title: "Siden blev ikke fundet | AA+PLUS MILJØSANERING", description: "404 – Siden blev ikke fundet." });
  return (
    <div data-testid="notfound-page" className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center">
        <div className="font-display font-extrabold text-7xl text-[#FF5A00]">404</div>
        <h1 className="mt-4 text-2xl font-bold text-gray-900">Siden blev ikke fundet</h1>
        <p className="mt-3 text-gray-600">Den side, du leder efter, findes ikke længere.</p>
        <Link to="/" data-testid="notfound-home-btn" className="mt-8 inline-flex bg-[#FF5A00] text-white font-semibold px-7 py-3.5 rounded-sm hover:bg-[#E04F00] transition-colors">Til forsiden</Link>
      </div>
    </div>
  );
};

export default NotFound;
